/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type SignupNudgePayloadSideEffectType =
  (typeof SignupNudgePayloadSideEffectType)[keyof typeof SignupNudgePayloadSideEffectType];

export const SignupNudgePayloadSideEffectType = {
  signup_nudge: "signup_nudge",
} as const;
